import DatePicker from "react-datepicker";
import CalendarIcon from "@/shared/assets/images/CalendarBlank.svg"
import * as yup from 'yup'
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { getAccrualReports } from "@/shared/api/community/community";

interface AccrualReportFormValues {
    start_date?: Date,
    end_date?: Date,
}

const initial: AccrualReportFormValues = {
    start_date: undefined,
    end_date: undefined,
}

const validationSchema = yup.object().shape({
    start_date: yup.date().required("Укажите дату начала"),
    end_date: yup.date().min(yup.ref('start_date'), "Некорректная дата").required("Укажите дату окончания"),
})

export const AccrualReportForm = () => {
    const {
        control,
        watch,
        handleSubmit,
        setValue,
        formState: {
            isSubmitting,
        },
    } = useForm<AccrualReportFormValues>({
        defaultValues: initial,
        resolver: yupResolver(validationSchema)
    })

    const onSubmit = async (data: AccrualReportFormValues) => {
        try {
            const responseBlob = await getAccrualReports(data.start_date!, data.end_date!)
            const url = window.URL.createObjectURL(new Blob([responseBlob.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('target', '_blank')
            link.setAttribute('download', 'accrual-report.xlsx')
            document.body.appendChild(link)
            link.click()
            link.parentNode?.removeChild(link)
        } catch (error) {
            console.error('Error creating report:', error)
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col h-full">
            <div className="flex flex-[1_1_auto] flex-col gap-2">
                <div className="flex flex-col gap-4">
                    <div>
                        <div className="mb-1 font-medium">
                            Начальная дата
                        </div>
                        <Controller
                            control={control}
                            name={'start_date'}
                            render={({ field }) => (
                                <DatePicker 
                                    selected={field.value}
                                    onChange={(date: Date | null) => setValue('start_date', date)}
                                    wrapperClassName="react-datepicker-form2"
                                    dateFormat={"dd.MM.yyyy"}
                                    showIcon
                                    placeholderText="Выберите начальную дату"
                                    enableTabLoop={false}
                                    popperProps={{
                                        placement: 'bottom'
                                    }}
                                    icon={(<CalendarIcon width={24} height={24}/>)}
                                />
                            )}
                        />
                    </div>
                    <div>
                        <div className="mb-1 font-medium">
                            Конечная дата
                        </div>
                        <Controller
                            control={control}
                            name={'end_date'}
                            render={({ field }) => (
                                <DatePicker 
                                    selected={field.value}
                                    minDate={watch('start_date')}
                                    onChange={(date: Date | null) => setValue('end_date', date)}
                                    wrapperClassName="react-datepicker-form2"
                                    dateFormat={"dd.MM.yyyy"}
                                    showIcon
                                    placeholderText="Выберите конечную дату"
                                    enableTabLoop={false}
                                    popperProps={{
                                        placement: 'bottom'
                                    }}
                                    icon={(<CalendarIcon width={24} height={24}/>)}
                                />
                            )}
                        />
                    </div>
                </div>
            </div>
            <div className="flex flex-[0_0_auto] flex-col gap-2">
                <button
                    type="submit" 
                    className="w-[400px] py-4 text-lg rounded-xl font-bold text-white bg-color-primary hover:bg-color-primary/70 transition"
                    disabled={isSubmitting}
                >
                    Создать отчет
                </button>
            </div>
        </form>
    )
}

